import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import RestorePassword from './RestorePassword';
import { requestEmail, annulError } from '../../reducers/restore-password/duck';

const mapStateToProps = ({ restorePasswordStore: { status, error } }) => ({
  status, error,

});
const mapDispatchToProps = {
  requestEmail,
  annulError,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RestorePassword));



// WEBPACK FOOTER //
// ./src/containers/RestorePassword/index.js